import eventBus from '@sd-utility/eventbus';
import Plpurl from '@tvg/product-listing-url';
import { EUserAction, PLP_FACET_UPDATE_EVENT } from 'client/config';
import { useNavigate } from 'client/router/useNavigate';
import { useMainState } from 'client/state/Main';
import { useCallback } from 'react';

export const usePLPNavigate = () => {
  const updatePLPURL = useMainState((s) => s.updatePLPURL);
  const setLastAction = useMainState((s) => s.setLastAction);
  const navigate = useNavigate();

  return useCallback(
    (change: Partial<Plpurl>, lastAction?: EUserAction) => {
      const plpurl = updatePLPURL({ ...change, pageNumber: change.pageNumber ?? 1 });
      const url = plpurl.generateUrl();

      setTimeout(() => {
        navigate(url);
        eventBus.publish(PLP_FACET_UPDATE_EVENT, { path: url });
      });

      setTimeout(() => {
        if (lastAction) setLastAction(lastAction);
      }, 250);
    },
    [navigate, setLastAction, updatePLPURL],
  );
};
